import ActionTypes from '../../../../constants/ActionTypes';
import { IProductSuggestionsState, ISetProductSuggestionsAction } from './types';

const initialState: IProductSuggestionsState = {
  items: []
};

const productSuggestionsReducer = (
  state = initialState,
  action: ISetProductSuggestionsAction,
): IProductSuggestionsState => {
  switch (action.type) {
  case ActionTypes.PRODUCT.SET_PRODUCT_SUGGESTIONS:
    return {
      ...state,
      items: action.payload
    };
  }
  return state;
};

export default productSuggestionsReducer;
